module.exports = __webpack_public_path__ + "public/media/creator.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/creator.png
// module id = ./images/services/creator.png
// module chunks = 0